<div
  nz-tooltip
  [nzTooltipTitle]="
    !hasChangePermissions ? ('general.forbidden_action' | translate) : ''
  "
>
  <csvbox-button
    class="csvbox-btn w-100"
    [language]="language"
    [licenseKey]="licenseKey"
    [imported]="imported.bind(this)"
    [user]="csvBoxUser"
    [lazy]="true"
    [disabled]="!hasChangePermissions"
    [importerReady]="onImporterReadyHandler.bind(this)"
    [loadStarted]="onLoadHandler.bind(this)"
  >
    {{ btnText }}
  </csvbox-button>
</div>
